<template>
  <v-container class="px-5 py-7" fluid>
    <v-img class="justify-center my-5 mx-0" src="https://swiset.com/wp-content/uploads/2020/05/Swiset_Imagotipo_RGB_Black.svg" max-height="17px" contain/>
    <h1 class="text-center">{{ $t('title') }}</h1>
    <p class="text-center mb-7">{{ $t('subtitle') }}</p>
    <v-row justify="center" align="center" class="mx-n5">
      <v-col cols="12" sm="12" md="12" lg="3" xl="3">
       <v-card class="pa-1 mx-0" outlined style="width: 100%; background-color: rgba(0,0,0,0)">
         <v-container fluid>
           <v-row justify="center"><h2>{{ $t('free.title') }}</h2></v-row>
           <v-row justify="center"><p>{{ $t('free.description') }}</p></v-row>
           <v-row justify="center" class="mb-n2"><v-btn class="mb-3" @click="continueFree">{{ $t('free.btnContinue') }}</v-btn></v-row>
         </v-container>
       </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="3" xl="3" v-for="plan in plans" v-bind:key="plan.planId">
        <PlanCard :plan="plan"/>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" class="mx-n5">
      <v-col cols="12" sm="12" md="12" lg="5" xl="5">
        <v-card class="py-5 px-1 mt-3" outlined style="width: 100%;background-color: #111111">
          <h2 style="color: #F8F8F8" class="text-center">{{ $t('featuresTitle') }}</h2>
          <v-list style="background-color: rgba(0,0,0,0)">
            <v-list-item v-for="feature in features" v-bind:key="feature.text" class="d-flex">
              <v-icon class="mr-2" color="#00F784" small>{{ feature.icon }}</v-icon>
              <p class="d-flex justify-start text-start mb-n2" style="color: #efefef">{{ feature.text }}</p>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <p class="text-center mt-4 mb-n2 px-12" style="font-size: 12px !important; color: #5a5a5a">{{ $t('terms') }}</p>
  </v-container>
</template>

<script>
import Plans from '../assets/pricingPlans';
import PlanCard from "@/components/PlanCard";
import Repository from '../repositories/suscription';

export default {
  name: "SwisetPlans",
  components: {PlanCard},
  props: {
    campaign: String,
  },
  data() {
    return {
      desktop: false,
      plans: [],
      features: [],

      confirmationInfo: {
        title: 'Payment created',
        text: 'We are waiting to confirm the PayPal transaction. Remember that Swiset isn\'t supported on mobile, you should visit Swiset at https://app.swiset.com on laptop/desktop.',
        buttonText: 'Go to Home',
        buttonUrl: 'open-on-desktop',
      },
    };
  },
  mounted() {
    this.desktop = screen.width >= 760;
    this.plans = (this.$i18n.locale === 'en') ? Plans.plansEN : Plans.plansES;
    this.features = (this.$i18n.locale === 'en') ? Plans.propertiesEN : Plans.propertiesES;
    const script = document.createElement("script");
    script.src = this.$store.state.paypalSubscriptionsScript;
    script.addEventListener("load", this.renderPaypalButtons);
    document.body.appendChild(script);
  },
  methods: {
    continueFree() {
      this.$router.push('/open-on-desktop');
    },
    // Paypal
    renderPaypalButtons(){
      var elements = document.querySelectorAll('.paypal-button-container');
      for(let i = 0; i < elements.length; i++) {
        if(this.plans[i].planName.includes('Lifetime')) {
          window.paypal.Buttons({
            style: {
              size: 'Small',
              color: this.plans[i].color,
              shape: 'pill',
            },
            createOrder: (data, actions) => {
              return actions.order.create({
                purchase_units: [
                  {
                    amount: {
                      currency_code: "USD",
                      value: this.plans[i].price.toString()
                    }
                  }
                ]
              });
            },
            onApprove: async (data, actions) => {
              return actions.order.capture().then((details) => {
                let subInfo = {
                  user_id: this.$store.state.currentUser.id,
                  subscription_id: data.orderID,
                  plan_id: this.plans[i].planId
                };
                if(details.status.toString() === 'COMPLETED') {
                  Repository.lifetimeSubscriptionCompleted(subInfo).then((response) => {
                    if(response.status < 400){
                      window.fbq('track', 'Purchase');
                      this.$router.push({
                        name: 'notification',
                        params: { title: this.confirmationInfo.title,
                          text: this.confirmationInfo.text,
                          buttonText: this.confirmationInfo.buttonText,
                          buttonUrl: this.confirmationInfo.buttonUrl}
                      });
                    }
                  });
                }
              });
            },
            onError: () => {
              alert(this.$t('gatewayError'));
            }
          }).render(elements[i]);
        }
        else{
          window.paypal.Buttons({
            style: {
              size: 'Small',
              color: this.plans[i].color,
              shape: 'pill',
            },
            createSubscription: (data, actions) => {
              return actions.subscription.create({
                'plan_id': this.plans[i].planId
              });
            },
            onApprove: async (data) => {
              let subInfo = {
                user_id: this.$store.state.currentUser.id,
                subscription_id: data.subscriptionID,
                plan_id: this.plans[i].planId
              };
              Repository.subscriptionApproved(subInfo).then((response) => {
                if(response.status < 400){
                  window.fbq('track', 'Purchase');
                  this.$router.push({
                    name: 'notification',
                    params: { title: this.confirmationInfo.title,
                      text: this.confirmationInfo.text,
                      buttonText: this.confirmationInfo.buttonText,
                      buttonUrl: this.confirmationInfo.buttonUrl}
                  });
                }
              });
            },
            onError: () => {
              alert(this.$t('gatewayError'));
            }
          }).render(elements[i]);
        }
      }
    },
  }
}
</script>

<i18n>
{
  "en": {
    "free": {
      "title": "Free",
      "description": "0 USD forever",
      "btnContinue" : "Continue Free »"
    },
    "title": "Get Swiset Pro!",
    "subtitle": "Swiset Pro: more targets, fewer stops.",
    "featuresTitle": "Buy now and get:",
    "terms": "By paying you agree our terms and conditions",
    "gatewayError": "There was an error with Paypal, please try again."
  },
  "es": {
    "free": {
    "title": "Gratis",
      "description": "0 USD por siempre",
      "btnContinue" : "Continuar Gratis »"
    },
    "title": "¡Conviértete a Pro!",
    "subtitle": "Swiset Pro: más targets, menos stops.",
    "featuresTitle": "Compra hoy y recibe:",
    "terms": "Al pagar estas aceptando nuestros términos y condiciones",
    "gatewayError": "Hubo un error con el pago, intente de nuevo por favor."
  }
}
</i18n>

<style scoped>

</style>
